// extracted by mini-css-extract-plugin
export var crack1 = "crackText-module--crack1--oHj8Q";
export var crack2 = "crackText-module--crack2--w994N";
export var cracktext = "crackText-module--cracktext--kB-pt";
export var shake = "crackText-module--shake--+9A+7";